import React from "react";
import { Spin } from 'antd';


export default class WidgetLoading extends React.Component 
{
    render() {
        const { children, loading, style = {} } = this.props
        return (
            <Spin 
                spinning={loading} 
                style={{ 
                    minHeight: '200px', 
                    ...style,
                }}
            >
                {children}
            </Spin>
        );
    }
}